import { point } from '../../../elements/point';
import { ICON_DEFAULT_FOREGROUND_COLOR } from '../../../graphConstants';
import { makeTag } from '../../../svg/utils';
import {
  type NodeIconOptions,
  type NodeTypeIcon,
  nodeIconDefaultOptions,
} from '../NodeTypeIcon';
import {
  createRectangleNodeTypeIcon,
  getArrowSvgPath,
  wrapNodeIconInSvgTag,
} from '../common';
import { drawRectangleBackground } from '../drawIconBackground';
import { drawAciGlyph } from './aciLeaf';

const ICON_WIDTH = 40;
const ICON_HEIGHT = 60;

function createAciSpineIcon(options: NodeIconOptions = {}): string {
  const opts = { ...nodeIconDefaultOptions, ...options };

  const drawSpineArrow = (startX: number, endX: number, y: number) =>
    makeTag('path', {
      d: getArrowSvgPath({
        from: point.create(startX, y),
        to: point.create(endX, y),
        headWidth: 6.8,
        headHeight: 5.2,
        tailWidth: 2.2,
      }),
      fill: ICON_DEFAULT_FOREGROUND_COLOR,
    });

  const icon = `
    ${drawRectangleBackground(ICON_WIDTH, ICON_HEIGHT, opts.style)}
    ${drawAciGlyph(32.8)}
    ${drawSpineArrow(18.4, 34.4, 7.2)}
    ${drawSpineArrow(21.6, 5.6, 12)}
    ${drawSpineArrow(18.4, 34.4, 16.8)}
    ${drawSpineArrow(21.6, 5.6, 21.6)}
    ${makeTag('line', {
      x1: 0,
      y1: 29.2,
      x2: ICON_WIDTH,
      y2: 29.2,
      stroke: ICON_DEFAULT_FOREGROUND_COLOR,
      'stroke-width': 1.4,
    })}
  `;

  return wrapNodeIconInSvgTag(icon, ICON_WIDTH, ICON_HEIGHT, 'topLeft', opts);
}

export const aciSpineIcon: NodeTypeIcon = createRectangleNodeTypeIcon(
  ICON_WIDTH,
  ICON_HEIGHT,
  createAciSpineIcon,
);
